export default function ToTop() {
  let prevScrollTop = 0
  const initialPos = $(document).scrollTop()
  const topTrigger = $('.js-scroll-top')
  const w = $(window)
  let firstLoad = true

  const hideTopTrigger = () => {
    topTrigger.addClass('hidden')
  }

  const showTopTrigger = () => {
    topTrigger.removeClass('hidden')
  }

  function onScroll(currentScrollTop) {
    const t = $(this)
    if (t.scrollTop() + t.height() == $(document).height()) {
      prevScrollTop = currentScrollTop
      showTopTrigger()
    } else if (t.scrollTop() == 0) {
      prevScrollTop = currentScrollTop
      hideTopTrigger()
    } else if (prevScrollTop >= currentScrollTop || (initialPos > 0 && firstLoad)) {
      prevScrollTop = currentScrollTop
      firstLoad = false
      showTopTrigger()
    } else {
      prevScrollTop = currentScrollTop
      hideTopTrigger()
    }
  }

  const init = () => {
    if (initialPos > 0) {
      showTopTrigger()
    }

    w.on('scroll', function () {
      let currentScrollTop = $(this).scrollTop()
      onScroll.call(this, currentScrollTop)
    })

    w.on('touchmove', function () {
      let currentScrollTop = $(this).scrollTop()
      onScroll.call(this, currentScrollTop)
    })

    topTrigger.on('click', () => {
      $('body, html').animate({ scrollTop: 0 }, 300)
    })
  }

  return {
    init: init,
  }
}
